<template>
  <b-modal ref="modal" hide-footer title="Thêm mới sản phẩm con cho combo">
    <v-form ref="form" lazy-validation>
      <b-row>
        <b-col>
          <b-form-group label="Chọn sản phẩm con:">
            <Autosuggest
              :model="localSearchProduct"
              :suggestions="filteredOptions"
              placeholder="sản phẩm con"
              :limit="10"
              @select="$emit('select', $event)"
              @change="onSearchChange"
            />
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Số lượng:" style="padding: 0px">
            <b-form-input
              size="sm"
              v-model="localQuantity"
              placeholder="Nhập SL"
              type="number"
              class="text-right"
              @input="updateValue('quantity')"
            ></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              Nhập ít nhất 1 ký tự
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label="Nhập giá tiền combo:">
            <b-form-input
              size="sm"
              v-model="localComboPrice"
              placeholder="Giá tiền combo"
              type="text"
              v-mask="mask"
              class="input-style text-right"
              @input="updateValue('comboPrice')"
            ></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              Nhập ít nhất 1 ký tự
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Nhập tỷ lệ phân bổ:" style="padding: 0px">
            <b-input-group size="sm" append="%">
              <b-form-input
                v-model="localComboRate"
                placeholder="Tỷ lệ phân bổ"
                class="input-style text-right"
                type="text"
                @input="updateValue('comboRate')"
              ></b-form-input>
            </b-input-group>
            <b-form-invalid-feedback id="input-live-feedback">
              Nhập ít nhất 1 ký tự
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <b-button
        style="fontweight: 600; width: 70px"
        variant="primary"
        size="sm"
        @click="$emit('save')"
        >Thêm</b-button
      >
      <b-button
        style="margin-left: 10px; font-weight: 600; width: 70px"
        variant="secondary"
        size="sm"
        @click="$emit('cancel')"
        >Hủy</b-button
      >
    </v-form>
  </b-modal>
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { currencyMask } from '@/utils/common';

export default {
  name: 'ProductComboModal',
  components: {
    Autosuggest,
  },
  props: {
    searchProduct: {
      type: String,
      default: '',
    },
    quantity: {
      type: [String, Number],
      default: 1,
    },
    comboPrice: {
      type: String,
      default: '',
    },
    comboRate: {
      type: String,
      default: '',
    },
    filteredOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localSearchProduct: this.searchProduct,
      localQuantity: this.quantity,
      localComboPrice: this.comboPrice,
      localComboRate: this.comboRate,
      mask: currencyMask,
    };
  },
  watch: {
    searchProduct(val) {
      this.localSearchProduct = val;
    },
    quantity(val) {
      this.localQuantity = val;
    },
    comboPrice(val) {
      this.localComboPrice = val;
    },
    comboRate(val) {
      this.localComboRate = val;
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onSearchChange(text) {
      this.localSearchProduct = text;
      this.$emit('change', text);
    },
    updateValue(key) {
      switch (key) {
        case 'quantity':
          this.$emit('update:quantity', this.localQuantity);
          break;
        case 'comboPrice':
          this.$emit('update:comboPrice', this.localComboPrice);
          break;
        case 'comboRate':
          this.$emit('update:comboRate', this.localComboRate);
          break;
      }
    },
  },
};
</script>
